module.exports = __webpack_public_path__ + "img/logo-warna.71d66504.png";